(function () {
  'use strict';

  var PAGE = '/pages/weekly-tarot-reading';
  var TYPE = 'Weekly Zodiac Tarot';
  var PRESENTATION = 'weekly-enterprise-v5';
  var API_PREVIEW = 'https://reading.deckaura.com/api/weekly-tarot/preview';
  var ALLOWED_SIGNS = ['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'];
  var ALLOWED_FOCUS = ['overall','love','career','money','wellbeing','decision'];
  var ALLOWED_TIMING = ['preparing','beginning','midweek','closing'];
  var ALLOWED_TIERS = ['deeper','indepth'];
  var CANONICAL_POSITIONS = ["Week's Theme",'Pressure Point','Best Response'];
  var dependencyLoads = {};

  function loadDependency(filename, ready) {
    if (ready()) return Promise.resolve();
    if (dependencyLoads[filename]) return dependencyLoads[filename];
    var task = new Promise(function (resolve, reject) {
      var original = document.querySelector('script[src*="/' + filename + '"]');
      if (!original) { reject(new Error('dependency_missing')); return; }
      var script = document.createElement('script'), settled = false;
      var timer = window.setTimeout(function () { finish(false); }, 10000);
      function finish(ok) {
        if (settled) return;
        settled = true; window.clearTimeout(timer); script.onload = script.onerror = null;
        if (ok && ready()) resolve(); else reject(new Error('dependency_unavailable'));
      }
      var url = new URL(original.src, window.location.href); url.searchParams.set('wtx_retry', String(Date.now()));
      script.src = url.href; script.async = true; script.onload = function () { finish(true); }; script.onerror = function () { finish(false); };
      document.head.appendChild(script);
    });
    dependencyLoads[filename] = task;
    task.then(function () { delete dependencyLoads[filename]; }, function () { delete dependencyLoads[filename]; });
    return task;
  }

  function q(root, selector) { return root.querySelector(selector); }
  function qa(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
  function pad(value) { return String(value).padStart(2, '0'); }
  function clean(value, limit) { return String(value || '').replace(/\s+/g, ' ').trim().slice(0, limit || 400); }
  function i18n() { return window.DeckauraWeeklyTarotI18n || null; }
  function text(key, values) {
    var api = i18n();
    return api && typeof api.string === 'function' ? api.string(key, values || {}) : key;
  }
  function analyticsSuppressed() { try { var params = new URLSearchParams(location.search); return params.has('funnel_audit') || params.get('internal') === 'true' || params.get('traffic_type') === 'internal' || params.has('deckaura_internal') || params.has('codex_audit') || params.has('alltools_audit'); } catch (_) { return false; } }
  function track(name, detail) {
    if (analyticsSuppressed()) return;
    var safe = detail || {};
    try { window.dispatchEvent(new CustomEvent('deckaura:analytics', {detail:{event:name,data:safe}})); } catch (_) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (_) {}
  }
  function visitorId() {
    var key = 'deckaura_visitor_v1';
    try {
      var existing = localStorage.getItem(key);
      if (existing && /^[a-zA-Z0-9_-]{16,96}$/.test(existing)) return existing;
      var bytes = new Uint8Array(18); crypto.getRandomValues(bytes);
      var next = 'v_' + Array.prototype.map.call(bytes, function (value) { return value.toString(16).padStart(2, '0'); }).join('');
      localStorage.setItem(key, next);
      return next;
    } catch (_) {
      return 'v_' + Date.now().toString(16) + Math.random().toString(36).slice(2, 12);
    }
  }
  function requestKey() {
    try { if (crypto.randomUUID) return crypto.randomUUID(); } catch (_) {}
    try {
      var bytes = new Uint8Array(16); crypto.getRandomValues(bytes);
      return Array.prototype.map.call(bytes, function (value) { return value.toString(16).padStart(2, '0'); }).join('');
    } catch (_) { return Date.now().toString(36) + Math.random().toString(36).slice(2, 18); }
  }
  function monday(date) {
    var value = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);
    value.setDate(value.getDate() - ((value.getDay() + 6) % 7));
    return value;
  }
  function iso(date) { return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()); }
  function weekInfo() {
    var start = monday(new Date());
    var end = new Date(start); end.setDate(start.getDate() + 6);
    var locale = i18n() && i18n().locale || 'en-US';
    var startLabel = start.toLocaleDateString(locale, {month:'short',day:'numeric'});
    var endLabel = end.toLocaleDateString(locale, {month:start.getMonth() === end.getMonth() ? undefined : 'short',day:'numeric'});
    return {start:start,end:end,key:iso(start),label:text('week', {start:startLabel,end:endLabel})};
  }
  function timingForToday() {
    var day = (new Date().getDay() + 6) % 7;
    return day <= 1 ? 'beginning' : day <= 3 ? 'midweek' : 'closing';
  }
  function sunSign(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value || ''))) return '';
    var parts = value.split('-').map(Number), md = parts[1] * 100 + parts[2];
    if (md >= 321 && md <= 419) return 'Aries';
    if (md >= 420 && md <= 520) return 'Taurus';
    if (md >= 521 && md <= 620) return 'Gemini';
    if (md >= 621 && md <= 722) return 'Cancer';
    if (md >= 723 && md <= 822) return 'Leo';
    if (md >= 823 && md <= 922) return 'Virgo';
    if (md >= 923 && md <= 1022) return 'Libra';
    if (md >= 1023 && md <= 1121) return 'Scorpio';
    if (md >= 1122 && md <= 1221) return 'Sagittarius';
    if (md >= 1222 || md <= 119) return 'Capricorn';
    if (md >= 120 && md <= 218) return 'Aquarius';
    return 'Pisces';
  }
  function validQuestion(value) {
    var question = clean(value, 240);
    var words = question.match(/[\p{L}\p{N}]+/gu) || [];
    return question.length >= 6 && words.length >= 2;
  }
  function scrollToNode(node) {
    if (!node) return;
    var reduced = false;
    try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_) {}
    var top = Math.max(0, window.scrollY + node.getBoundingClientRect().top - 104);
    window.scrollTo({top:top,behavior:reduced ? 'auto' : 'smooth'});
  }
  function localizedDateRanges(root) {
    var locale = i18n() && i18n().locale || 'en-US';
    qa(root, '[data-wtx-dates]').forEach(function (button) {
      var parts = String(button.getAttribute('data-wtx-dates') || '').split('|');
      if (parts.length !== 2) return;
      var format = function (value) {
        var date = value.split('-').map(Number);
        return new Date(2024, date[0] - 1, date[1], 12).toLocaleDateString(locale, {month:'short',day:'numeric'});
      };
      var target = q(button, 'small'); if (target) target.textContent = format(parts[0]) + '–' + format(parts[1]);
    });
  }
  function localeContext(root) {
    var source = window.DeckauraLocale || {}, activeCurrency = '', shopCountry = '';
    try { activeCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || ''; } catch (_) {}
    try { shopCountry = window.Shopify && window.Shopify.country || ''; } catch (_) {}
    var locale = clean(source.locale || root.getAttribute('data-locale') || document.documentElement.lang || 'en', 24);
    var country = clean(source.country || shopCountry || 'US', 2).toUpperCase();
    var currency = clean(source.currency || activeCurrency || 'USD', 3).toUpperCase();
    var market = clean(source.market || country.toLowerCase(), 64).toLowerCase();
    if (!/^[A-Z]{2}$/.test(country)) country = 'US';
    if (!/^[A-Z]{3}$/.test(currency)) currency = 'USD';
    return {locale:locale,country:country,currency:currency,market:market};
  }
  function normalizeCard(value, index) {
    var source = value && typeof value === 'object' ? value : {};
    var name = clean(source.name || source.card, 100), orientation = clean(source.orientation, 16);
    if (!name || !/^(Upright|Reversed)$/.test(orientation)) return null;
    return {id:String(source.id == null ? '' : source.id),name:name,position:clean(source.position, 42),orientation:orientation,index:index};
  }
  function validatePreview(data, expected) {
    if (!data || data.ok !== true || !/^[a-f0-9]{32}$/i.test(String(data.token || ''))) return null;
    if (data.presentationVariant !== PRESENTATION || !/^[a-z0-9_-]{8,80}$/i.test(String(data.readingId || ''))) return null;
    var cards = Array.isArray(data.cards) ? data.cards.map(normalizeCard) : [];
    if (cards.length !== 3 || cards.some(function (card) { return !card; })) return null;
    var snapshot = data.snapshot;
    if (!snapshot || typeof snapshot !== 'object' || Array.isArray(snapshot)) return null;
    if (snapshot.version !== 'reading-snapshot-v2' || snapshot.presentationVariant !== PRESENTATION || String(snapshot.readingId || '') !== String(data.readingId)) return null;
    if (snapshot.type !== TYPE || snapshot.spread !== 'Theme · Pressure · Response' || snapshot.tool !== 'Weekly Tarot Reading') return null;
    if (clean(snapshot.question, 400) !== expected.question || snapshot.curiosityQuestion !== expected.question || snapshot.weekKey !== expected.weekKey || snapshot.sign !== expected.sign || snapshot.focus !== expected.focus || snapshot.timing !== expected.timing) return null;
    if (!snapshot.context || !snapshot.scope || !snapshot.confidence || typeof snapshot.cards !== 'string' || !clean(snapshot.cards, 2000) || snapshot.cards !== snapshot.signals) return null;
    var locale = snapshot.localeContext;
    if (!locale || typeof locale !== 'object' || Array.isArray(locale) || !clean(locale.locale, 24) || !clean(locale.language, 16) || !/^[A-Z]{2}$/.test(String(locale.country || '')) || !/^[A-Z]{3}$/.test(String(locale.currency || '')) || !clean(locale.market, 64)) return null;
    var evidence = Array.isArray(snapshot.cardEvidence) ? snapshot.cardEvidence.map(normalizeCard) : [];
    var positions = Array.isArray(snapshot.positions) ? snapshot.positions.map(function (position) { return clean(position, 42); }) : [];
    if (evidence.length !== 3 || positions.length !== 3 || evidence.some(function (card) { return !card; })) return null;
    for (var index = 0; index < 3; index += 1) {
      if (positions[index] !== CANONICAL_POSITIONS[index] || cards[index].id !== evidence[index].id || cards[index].name !== evidence[index].name || cards[index].position !== evidence[index].position || cards[index].orientation !== evidence[index].orientation || evidence[index].position !== positions[index]) return null;
    }
    return {token:String(data.token),expiresAt:String(data.expiresAt || ''),readingId:String(data.readingId),cards:cards,snapshot:snapshot};
  }

  function init(root) {
    if (!root || root.getAttribute('data-wtx-ready') === 'true') return;
    root.setAttribute('data-wtx-ready', 'true');
    var week = weekInfo();
    var storageKey = 'deckaura.weekly.v5.' + week.key;
    var legacyKey = 'deckaura.weekly.v3.' + week.key;
    var state = {step:'sign',sign:'',focus:'',timing:timingForToday(),question:'',tier:'deeper',preview:null,pricing:null,fetching:false,checkoutPending:false,idempotencyKey:'',requestVersion:0};
    var sessionVisitorId = visitorId();
    var setup = q(root, '[data-wtx-setup]');
    var result = q(root, '[data-wtx-result]');
    var reading = q(root, '[data-wtx-reading]');
    var sticky = q(root, '[data-wtx-sticky]');
    var mainCheckout = q(root, '.wtx-checkout');
    var mainCheckoutVisible = false;
    var priceRetryLabel = q(root, '[data-wtx-price-retry]').textContent;
    var funnelSent = {}, checkoutRun = 0, checkoutTimer = 0, activeCheckout = null, cartReview = null;

    try { sessionStorage.removeItem(legacyKey); } catch (_) {}
    localizedDateRanges(root);
    qa(root, '[data-wtx-current-week], [data-wtx-current-week-art]').forEach(function (node) { node.textContent = week.label; });

    function funnel(name, detail, key) {
      if (analyticsSuppressed()) return;
      var eventKey = key || name;
      if (funnelSent[eventKey]) return;
      funnelSent[eventKey] = true;
      var payload = {event:name,tool:'weekly-tarot-reading',component_version:'enterprise-v5'};
      Object.keys(detail || {}).forEach(function (property) { payload[property] = detail[property]; });
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch (_) {}
      try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (_) {}
    }
    function save() {
      try { sessionStorage.setItem(storageKey, JSON.stringify({sign:state.sign,focus:state.focus,timing:state.timing,question:state.question,tier:state.tier,ts:Date.now()})); } catch (_) {}
    }
    function restore() {
      try {
        var saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
        if (!saved || Date.now() - Number(saved.ts || 0) > 7 * 24 * 60 * 60 * 1000) return;
        if (ALLOWED_SIGNS.indexOf(saved.sign) >= 0) state.sign = saved.sign;
        if (ALLOWED_FOCUS.indexOf(saved.focus) >= 0) state.focus = saved.focus;
        if (ALLOWED_TIMING.indexOf(saved.timing) >= 0) state.timing = saved.timing;
        if (typeof saved.question === 'string') state.question = saved.question.slice(0, 240);
        if (ALLOWED_TIERS.indexOf(saved.tier) >= 0) state.tier = saved.tier;
      } catch (_) {}
    }
    function signLabel() {
      var selected = q(root, '[data-wtx-sign="' + state.sign + '"] b');
      return selected ? clean(selected.textContent, 40) : state.sign;
    }
    function focusLabel() { return i18n() ? i18n().focus(state.focus) : state.focus; }
    function timingLabel() { return i18n() ? i18n().timing(state.timing) : state.timing; }
    function packageName(tier) { return i18n() ? i18n().packageName(tier) : tier; }
    function clearCartReview() {
      cartReview = null;
      var host = q(root, '[data-wtx-checkout-recovery-host]');
      if (host) { host.__deckauraRecoveryGeneration = (host.__deckauraRecoveryGeneration || 0) + 1; host.replaceChildren(); host.hidden = true; }
    }
    function selectionKey() { return JSON.stringify([state.preview && state.preview.readingId, state.requestVersion, state.tier]); }
    function checkoutCartReviewPending() { return !!cartReview && cartReview.key === selectionKey() && !result.hidden; }
    function clearCheckoutTimer() { if (checkoutTimer) window.clearTimeout(checkoutTimer); checkoutTimer = 0; }
    function dismissReturnHint() { try { var guard = window.DeckauraCheckout; if (guard && typeof guard.dismissRecovery === 'function') guard.dismissRecovery(); } catch (_) {} }
    function cartReviewReady(host) {
      if (!state.preview || result.hidden || host !== q(root, '[data-wtx-checkout-recovery-host]') || !host.isConnected) return;
      state.checkoutPending = false; clearCheckoutTimer(); dismissReturnHint(); syncPackageUI(); updateSticky();
      q(root, '[data-wtx-price-status]').textContent = ''; host.tabIndex = -1; host.focus({preventScroll:true}); scrollToNode(host);
    }
    function selectPackage(tier) {
      if (state.checkoutPending || !state.preview || result.hidden || ALLOWED_TIERS.indexOf(tier) < 0) return false;
      if (state.tier !== tier) { checkoutRun += 1; clearCheckoutTimer(); clearCartReview(); }
      state.tier = tier; save(); syncPackageUI(); updateSticky(); return true;
    }
    function checkoutCurrent(operation) { return !!operation && operation.run === checkoutRun && operation.preview === state.preview && operation.version === state.requestVersion && operation.tier === state.tier && !result.hidden; }
    function recoverableCartReason(reason) { return /^(?:reading_cart_conflict|cart_changed|cart_operation_busy|cart_result_uncertain|cart_read_failed|cart_add_failed|checkout_guard_unavailable|checkout_navigation_busy)$/.test(String(reason || '')); }
    function invalidatePreview() {
      checkoutRun += 1; activeCheckout = null; clearCheckoutTimer(); clearCartReview();
      var hadAuthority = Boolean(state.preview || state.pricing || state.idempotencyKey);
      state.requestVersion += 1; state.preview = null; state.pricing = null; state.checkoutPending = false; state.idempotencyKey = '';
      state.authorityExpired = false;
      if (hadAuthority) try { if (window.DeckauraDeepReading && typeof window.DeckauraDeepReading.disable === 'function') window.DeckauraDeepReading.disable(); } catch (_) {}
      updateSticky(); syncPackageUI();
    }
    function refreshWeek() {
      var current = weekInfo();
      if (current.key !== week.key) {
        invalidatePreview(); week = current; storageKey = 'deckaura.weekly.v5.' + week.key;
        state.timing = timingForToday();
      } else week = current;
      qa(root, '[data-wtx-current-week], [data-wtx-current-week-art]').forEach(function (node) { node.textContent = week.label; });
    }
    function syncRoving(selector, selectedValue, attribute) {
      var buttons = qa(root, selector), selectedIndex = -1;
      buttons.forEach(function (button, index) { if (button.getAttribute(attribute) === selectedValue) selectedIndex = index; });
      buttons.forEach(function (button, index) {
        var selected = index === selectedIndex;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
        button.tabIndex = selected ? 0 : selectedIndex < 0 && index === 0 ? 0 : -1;
      });
    }
    function syncChoices() {
      syncRoving('[data-wtx-sign]', state.sign, 'data-wtx-sign');
      syncRoving('[data-wtx-focus]', state.focus, 'data-wtx-focus');
      q(root, '[data-wtx-next="focus"]').disabled = !state.sign;
      var input = q(root, '[data-wtx-question]');
      if (document.activeElement !== input) input.value = state.question;
      q(root, '[data-wtx-timing]').value = state.timing;
      q(root, '[data-wtx-timing-label]').textContent = timingLabel();
      q(root, '[data-wtx-reveal]').disabled = state.fetching || !(state.sign && state.focus && validQuestion(input.value));
    }
    function showStep(name, shouldScroll, shouldFocus) {
      var order = ['sign','focus'], index = Math.max(0, order.indexOf(name));
      state.step = order[index];
      qa(root, '[data-wtx-panel]').forEach(function (panel) {
        var active = panel.getAttribute('data-wtx-panel') === state.step;
        panel.hidden = !active; panel.classList.toggle('is-active', active);
      });
      qa(root, '[data-wtx-progress]').forEach(function (button, buttonIndex) {
        var active = buttonIndex === index, complete = buttonIndex < index;
        button.classList.toggle('is-active', active); button.classList.toggle('is-complete', complete);
        button.disabled = buttonIndex > index || (buttonIndex === 1 && !state.sign);
        if (active) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current');
        q(button, 'i').textContent = complete ? '✓' : String(buttonIndex + 1);
      });
      q(root, '[data-wtx-progress-copy]').textContent = text('step', {n:index + 1});
      syncChoices(); save();
      if (shouldScroll) scrollToNode(setup);
      if (shouldFocus) window.setTimeout(function () {
        var panel = q(root, '[data-wtx-panel="' + state.step + '"]');
        var target = panel && q(panel, '[role="radio"][tabindex="0"], input:not(:disabled), textarea:not(:disabled)');
        if (target) { try { target.focus({preventScroll:true}); } catch (_) { target.focus(); } }
      }, 50);
      track('weekly_setup_step', {step:state.step,step_number:index + 1});
    }
    function addRadioKeyboard(button, selector) {
      button.addEventListener('keydown', function (event) {
        if (button.disabled) return;
        if (!/^(ArrowLeft|ArrowRight|ArrowUp|ArrowDown|Home|End)$/.test(event.key)) return;
        event.preventDefault();
        var buttons = qa(root, selector), index = buttons.indexOf(button), next = index;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        else next = (index + (/^(ArrowLeft|ArrowUp)$/.test(event.key) ? -1 : 1) + buttons.length) % buttons.length;
        buttons[next].click(); buttons[next].focus();
      });
    }
    function pricingTier(tier) {
      var tiers = state.pricing && Array.isArray(state.pricing.tiers) ? state.pricing.tiers : [];
      for (var index = 0; index < tiers.length; index += 1) if (tiers[index].tier === tier) return tiers[index];
      return null;
    }
    function syncPackageUI() {
      var api = window.DeckauraDeepReading;
      var runtimeTier = api && typeof api.getSelectedTier === 'function' ? api.getSelectedTier() : '';
      var ready = Boolean(state.preview && !state.authorityExpired && api && runtimeTier === state.tier && typeof api.isPriceReady === 'function' && api.isPriceReady());
      var quote = pricingTier(state.tier);
      var selectedPrice = quote && quote.formatted_price ? quote.formatted_price : text('checking');
      syncRoving('[data-wtx-package]', state.tier, 'data-wtx-package');
      qa(root, '[data-wtx-package]').forEach(function (button) {
        var tier = button.getAttribute('data-wtx-package'), tierQuote = pricingTier(tier), price = q(root, '[data-wtx-package-price="' + tier + '"]');
        button.disabled = state.checkoutPending;
        if (price) price.textContent = tierQuote && tierQuote.formatted_price ? tierQuote.formatted_price : text('checking');
      });
      qa(root, '[data-wtx-adjust], [data-wtx-edit-offer], [data-wtx-again]').forEach(function (button) { button.disabled = state.checkoutPending; });
      var faq = q(root, '[data-wtx-faq-price]'), focused = pricingTier('deeper'), indepth = pricingTier('indepth');
      if (faq) faq.textContent = focused && indepth && focused.available !== false && indepth.available !== false && focused.formatted_price && indepth.formatted_price ? text('faq_prices', {focused:focused.formatted_price,indepth:indepth.formatted_price}) : text('faq_free');
      qa(root, '[data-wtx-checkout]').forEach(function (button) {
        button.disabled = !ready || state.checkoutPending;
        button.setAttribute('aria-busy', state.checkoutPending || !ready ? 'true' : 'false');
        if (button.closest('.wtx-sticky')) button.textContent = state.checkoutPending ? text('opening') : text('continue');
        else button.textContent = state.checkoutPending ? text('opening') : ready ? text('continue_package', {name:packageName(state.tier),price:selectedPrice}) : text('checking');
      });
      q(root, '[data-wtx-sticky-name]').textContent = packageName(state.tier);
      q(root, '[data-wtx-sticky-price]').textContent = selectedPrice;
      var status = q(root, '[data-wtx-price-status]'), retry = q(root, '[data-wtx-price-retry]');
      var pricingStatus = state.pricing && state.pricing.status || 'loading';
      if (status) status.textContent = state.authorityExpired ? text('checkout_expired') : ready ? (pricingStatus === 'error' ? text('price_fallback') : '') : pricingStatus === 'error' ? text('price_error') : text('confirming');
      if (retry) { retry.hidden = !state.authorityExpired && (ready || pricingStatus !== 'error'); retry.textContent = state.authorityExpired ? q(root, '[data-wtx-adjust]').textContent : priceRetryLabel; }
    }
    function syncPricing(snapshot) {
      if (snapshot && typeof snapshot === 'object') state.pricing = snapshot;
      var api = window.DeckauraDeepReading, quote = pricingTier(state.tier), status = state.pricing && state.pricing.status;
      if (state.preview && quote && quote.available !== false && (status === 'ready' || status === 'fallback_ready')) {
        try {
          if (api && typeof api.setTier === 'function' && (!api.getSelectedTier || api.getSelectedTier() !== state.tier)) api.setTier(state.tier, 'weekly_pricing_ready');
        } catch (_) {}
      }
      syncPackageUI();
    }
    function updateSticky() {
      var host = q(root, '[data-wtx-checkout-recovery-host]');
      var show = Boolean(state.preview && !result.hidden && !mainCheckoutVisible && !checkoutCartReviewPending() && !(host && !host.hidden));
      sticky.hidden = !show; sticky.classList.toggle('is-visible', show);
    }
    function cardName(card) { return i18n() ? i18n().cardName(card.name) : card.name; }
    function cardTheme(card) { return i18n() ? i18n().cardTheme(card.name, card.orientation === 'Reversed') : card.name; }
    function cardOrientation(card) { return i18n() ? i18n().orientation(card.orientation === 'Reversed') : card.orientation; }
    function cardImageUrl(url, width) { return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width; }
    function createCard(card, index) {
      var article = document.createElement('article'); article.className = 'wtx-card' + (card.orientation === 'Reversed' ? ' is-reversed' : ''); article.setAttribute('role','listitem');
      var role = document.createElement('small'); role.className = 'wtx-card__role'; role.textContent = pad(index + 1) + ' · ' + (i18n() ? i18n().role(index) : card.position);
      var identity = document.createElement('div'); identity.className = 'wtx-card__identity';
      var art = document.createElement('div'); art.className = 'wtx-card__art';
      var artMap = {}, mapped = '';
      try { var artNode = document.getElementById('tarotCardArtMap'); artMap = artNode ? JSON.parse(artNode.textContent || '{}') : {}; } catch (_) { artMap = {}; }
      try { mapped = window.DeckauraTarotArt ? window.DeckauraTarotArt.url(card.name, 320) : artMap[String(card.id)]; } catch (_) { mapped = ''; }
      if (mapped) {
        var image = document.createElement('img'); image.src = cardImageUrl(mapped, 240); image.srcset = cardImageUrl(mapped, 160) + ' 160w, ' + cardImageUrl(mapped, 240) + ' 240w'; image.sizes = '(max-width: 760px) 72px, 92px'; image.alt = text('card_alt', {name:cardName(card)}); image.loading = 'eager'; image.decoding = 'async'; image.width = 184; image.height = 276; art.appendChild(image);
      } else { var glyph = document.createElement('span'); glyph.textContent = '✦'; art.appendChild(glyph); }
      var copy = document.createElement('div'), title = document.createElement('h3'), orientation = document.createElement('span');
      title.textContent = cardName(card); orientation.className = 'wtx-card__orientation'; orientation.textContent = cardOrientation(card); copy.appendChild(title); copy.appendChild(orientation); identity.appendChild(art); identity.appendChild(copy);
      var meaning = document.createElement('p'); meaning.className = 'wtx-card__meaning';
      var values = {name:cardName(card),orientation:cardOrientation(card),theme:cardTheme(card)};
      meaning.textContent = text(index === 0 ? 'theme_card' : index === 1 ? 'pressure_card' : 'response_card', values);
      article.appendChild(role); article.appendChild(identity); article.appendChild(meaning); return article;
    }
    function updateContext(cards) {
      var list = q(root, '[data-wtx-context-chips]'); list.textContent = '';
      [signLabel(),focusLabel(),timingLabel(),week.label].forEach(function (label) { var item = document.createElement('li'); item.textContent = label; list.appendChild(item); });
      q(root, '[data-wtx-offer-question]').textContent = '“' + state.question + '”';
      var cardList = q(root, '[data-wtx-offer-cards]'); cardList.textContent = '';
      cards.forEach(function (card) { var item = document.createElement('li'); item.textContent = cardName(card) + ' · ' + cardOrientation(card); cardList.appendChild(item); });
    }
    function renderResult() {
      var cards = state.preview.cards;
      q(root, '[data-wtx-result-title]').textContent = text('result_title', {sign:signLabel(),focus:focusLabel(),timing:timingLabel()});
      q(root, '[data-wtx-week-label]').textContent = week.label;
      q(root, '[data-wtx-one-line]').textContent = text('surface', {question:state.question,theme:cardName(cards[0]),pressure:cardName(cards[1]),response:cardName(cards[2])});
      var cardGrid = q(root, '[data-wtx-cards]'); cardGrid.textContent = ''; cards.forEach(function (card, index) { cardGrid.appendChild(createCard(card, index)); });
      q(root, '[data-wtx-critical-question]').textContent = text('critical', {response:cardName(cards[2]),responseTheme:cardTheme(cards[2]),pressure:cardName(cards[1])});
      updateContext(cards); setup.hidden = true; result.hidden = false; updateSticky();
      track('weekly_reading_complete', {sun_sign:state.sign,focus:state.focus,week_position:state.timing,week:week.key,question_added:true,source:'verified_preview'});
      funnel('reading_revealed', {sun_sign:state.sign,focus:state.focus,week_position:state.timing,week:week.key,question_added:true}, 'reading_revealed');
      window.setTimeout(function () { scrollToNode(result); try { result.focus({preventScroll:true}); } catch (_) { result.focus(); } }, 50);
    }
    function configureReading() {
      var attempts = 0, preview = state.preview, version = state.requestVersion;
      return new Promise(function (resolve, reject) {
      function failed(stale) {
        if (!stale) { state.pricing = {status:'error',tiers:[]}; syncPackageUI(); }
        reject({stale:Boolean(stale),code:'price_error'});
      }
      function run() {
        if (!preview || state.preview !== preview || state.requestVersion !== version) { failed(true); return; }
        attempts += 1;
        var api = window.DeckauraDeepReading;
        if (!api || typeof api.enable !== 'function') {
          if (attempts < 70) window.setTimeout(run, 100);
          else failed(false);
          return;
        }
        var snapshot = preview.snapshot;
        try {
          var checkoutProperties = {};
          checkoutProperties[text('property_week')] = week.label;
          checkoutProperties[text('property_sign')] = state.sign;
          checkoutProperties[text('property_focus')] = focusLabel();
          checkoutProperties[text('property_timing')] = timingLabel();
          checkoutProperties['_Week key'] = week.key;
          checkoutProperties['_Verified preview'] = preview.readingId;
          checkoutProperties[text('property_question')] = snapshot.question;
          checkoutProperties[text('property_cards')] = preview.cards.map(function (card) { return card.position + ': ' + card.name + ' ' + card.orientation; }).join('; ');
          api.enable({
            type:snapshot.type,context:snapshot.context,question:snapshot.question,signals:snapshot.signals,signalLimit:3,cards:snapshot.cards,cardLimit:3,
            spread:snapshot.spread,scope:snapshot.scope,confidence:snapshot.confidence,focus:snapshot.focus,tool:snapshot.tool,
            curiosityQuestion:snapshot.curiosityQuestion,presentationVariant:PRESENTATION,readingId:snapshot.readingId,
            canonicalPage:PAGE,visitorId:sessionVisitorId,previewToken:preview.token,transportFallback:false,checkoutPending:false,authoritativeSnapshot:snapshot,
            requireContext:false,defaultTier:state.tier,resultReady:true,analyticsTopic:'weekly-tarot',gate:false,teaser:false,
            packageLabels:{deeper:packageName('deeper'),indepth:packageName('indepth')},
            checkoutProperties:checkoutProperties,
            checkoutRecoveryHost:q(root, '[data-wtx-checkout-recovery-host]'),
            onCartReviewReady:function (host) { if (state.preview === preview && state.requestVersion === version) cartReviewReady(host); },
            checkoutGuard:function (selected) { return state.preview === preview && state.requestVersion === version && !result.hidden && selected.tier === state.tier; },
            onTierChange:function (tier) { if (state.preview === preview && state.requestVersion === version) selectPackage(tier); },
            onPricingStateChange:function (pricing) { if (state.preview === preview && state.requestVersion === version) syncPricing(pricing); },
            onPriceReady:function () { if (state.preview === preview && state.requestVersion === version && api.getPricingSnapshot) syncPricing(api.getPricingSnapshot()); }
          });
          if (typeof api.setPreviewAuthorization === 'function') api.setPreviewAuthorization({previewToken:preview.token,transportFallback:false});
          if (typeof api.setCheckoutPending === 'function') api.setCheckoutPending(false);
          if (api.setTier) api.setTier(state.tier, 'weekly_result');
          if (api.hide) api.hide();
          if (api.getPricingSnapshot) syncPricing(api.getPricingSnapshot());
          resolve();
        } catch (_) { failed(false); }
      }
      run();
      });
    }
    function previewError(status, code) {
      var normalized = String(code || '').toUpperCase();
      if (normalized.indexOf('SAFETY') >= 0) return 'safety_error';
      if (status === 429 || normalized.indexOf('RATE') >= 0 || normalized.indexOf('LIMIT') >= 0) return 'rate_limit';
      if (status === 422 || normalized.indexOf('QUESTION') >= 0 || normalized.indexOf('INPUT') >= 0 || normalized.indexOf('INVALID') >= 0) return 'question_error';
      if (status === 503 || normalized.indexOf('UNAVAILABLE') >= 0) return 'service_unavailable';
      return 'preview_error';
    }
    function requestPreview(options) {
      var previous = options && options.resumeCheckout ? state.preview : null;
      var version = ++state.requestVersion, startedAt = Date.now(), context = localeContext(root);
      if (!state.idempotencyKey) state.idempotencyKey = requestKey();
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = controller ? window.setTimeout(function () { controller.abort(); }, 10000) : 0;
      var body = {visitorId:sessionVisitorId,idempotencyKey:state.idempotencyKey,weekKey:week.key,sign:state.sign,focus:state.focus,timing:state.timing,question:state.question,locale:context.locale,country:context.country,currency:context.currency,market:context.market};
      if (previous) body.resumeCheckout = true;
      funnel('free_result_requested', {week:week.key,focus:state.focus}, 'free_result_requested:' + state.idempotencyKey);
      return fetch(API_PREVIEW, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),signal:controller ? controller.signal : undefined})
        .then(function (response) { return response.json().catch(function () { return {}; }).then(function (data) { return {ok:response.ok,status:response.status,data:data}; }); })
        .then(function (response) {
          if (version !== state.requestVersion) throw {stale:true};
          var expected = {question:state.question,weekKey:week.key,sign:state.sign,focus:state.focus,timing:state.timing};
          var preview = response.ok ? validatePreview(response.data, expected) : null;
          if (!preview) throw {status:response.status || 500,serverCode:String(response.data && response.data.code || ''),code:previewError(response.status, response.data && (response.data.code || response.data.error || response.data.reason))};
          if (previous && (previous.token !== preview.token || previous.readingId !== preview.readingId || JSON.stringify(previous.cards) !== JSON.stringify(preview.cards))) throw {code:'preview_error'};
          state.preview = preview; state.pricing = null;
          funnel('free_result_resolved', {status:'success',latency_ms:Date.now() - startedAt}, 'free_result_resolved:' + preview.readingId);
          return preview;
        })
        .finally(function () { if (timer) window.clearTimeout(timer); });
    }
    function reveal() {
      if (state.fetching) return;
      refreshWeek();
      var input = q(root, '[data-wtx-question]'), error = q(root, '[data-wtx-error]');
      state.question = clean(input.value, 240); error.textContent = ''; input.removeAttribute('aria-invalid');
      if (!state.sign) { error.textContent = text('sign_error'); showStep('sign', true, true); return; }
      if (!state.focus) { error.textContent = text('focus_error'); showStep('focus', true, true); return; }
      if (!validQuestion(state.question)) { error.textContent = text('question_error'); input.setAttribute('aria-invalid','true'); input.focus(); return; }
      state.fetching = true; save(); syncChoices(); q(root, '[data-wtx-reveal-label]').textContent = text('drawing');
      requestPreview().then(function () { renderResult(); configureReading().catch(function () {}); })
        .catch(function (failure) {
          if (failure && failure.stale) return;
          state.preview = null;
          var key = failure && failure.code || (failure && failure.name === 'AbortError' ? 'service_unavailable' : 'preview_error');
          error.textContent = text(key);
          funnel('free_result_resolved', {status:'error',reason:key}, 'free_result_error:' + state.idempotencyKey);
        })
        .finally(function () { state.fetching = false; syncChoices(); q(root, '[data-wtx-reveal-label]').textContent = state.preview ? text('reveal') : text('preview_retry'); });
    }
    function returnToSetup() {
      if (state.checkoutPending) return;
      result.hidden = true; setup.hidden = false; invalidatePreview(); showStep('focus', true, true);
    }
    function retryPricing() {
      if (state.authorityExpired) { returnToSetup(); return; }
      var api = window.DeckauraDeepReading; state.pricing = {status:'loading',tiers:state.pricing && state.pricing.tiers || []}; syncPackageUI();
      if (api && typeof api.retryPricing === 'function') api.retryPricing();
      else loadDependency('deep-reading-cta-runtime.js', function () { return window.DeckauraDeepReading && typeof window.DeckauraDeepReading.enable === 'function'; })
        .then(function () { return configureReading(); })
        .catch(function (failure) { if (!failure || !failure.stale) { state.pricing = {status:'error',tiers:[]}; syncPackageUI(); } });
      track('weekly_price_retry', {tier:state.tier});
    }
    var lastCheckoutCode = '';
    document.addEventListener('deckaura:funnel-event', function (event) {
      var detail = event.detail || {}, data = detail.data || {}, canonical = String(data.page || data.tool || '');
      if (canonical !== PAGE || (data.presentation_variant && data.presentation_variant !== PRESENTATION) || !state.preview || result.hidden) return;
      if (data.reading_id && data.reading_id !== state.preview.readingId) return;
      if (detail.name === 'checkout_prepare_start' && (state.checkoutPending || checkoutCartReviewPending())) {
        if (checkoutCartReviewPending()) { checkoutRun += 1; activeCheckout = {run:checkoutRun,preview:state.preview,version:state.requestVersion,tier:state.tier,async:false}; }
        if (activeCheckout && checkoutCurrent(activeCheckout)) activeCheckout.prepareStarted = true;
        cartReview = null; state.checkoutPending = true; clearCheckoutTimer(); syncPackageUI(); updateSticky();
      }
      if (detail.name === 'checkout_prepare_error' && state.checkoutPending) {
        lastCheckoutCode = String(data.code || ''); var reason = String(data.reason || data.status || '');
        if (recoverableCartReason(reason)) { cartReview = {key:selectionKey(),reason:reason}; state.checkoutPending = false; clearCheckoutTimer(); syncPackageUI(); updateSticky(); q(root, '[data-wtx-price-status]').textContent = ''; }
        else if (activeCheckout && !activeCheckout.async && checkoutCurrent(activeCheckout)) { state.checkoutPending = false; clearCheckoutTimer(); syncPackageUI(); q(root, '[data-wtx-price-status]').textContent = text('checkout_error'); }
      }
    });
    function resumeCheckout() {
      var previous = state.preview, run = checkoutRun, tier = state.tier;
      function current() { return run === checkoutRun && state.checkoutPending && tier === state.tier && !result.hidden; }
      q(root, '[data-wtx-price-status]').textContent = text('restoring_checkout');
      return requestPreview({resumeCheckout:true}).then(function () { if (!current()) throw {stale:true}; return configureReading(); }).then(function () {
        if (!current()) throw {stale:true};
        var preview = state.preview, deadline = Date.now() + 15000;
        return new Promise(function (resolve, reject) {
          function check() {
            var api = window.DeckauraDeepReading;
            if (!current() || state.preview !== preview) { reject({stale:true}); return; }
            if (api && api.isPriceReady && api.isPriceReady() && api.getSelectedTier() === state.tier) { resolve(); return; }
            if (Date.now() >= deadline) { reject({code:'price_error'}); return; }
            window.setTimeout(check, 100);
          }
          check();
        });
      }).then(function () { if (!current()) return; state.checkoutPending = false; checkout(true); }).catch(function (failure) {
        if (!current() || failure && failure.stale) return;
        if (!state.preview) state.preview = previous;
        state.authorityExpired = Boolean(failure && failure.serverCode === 'WEEKLY_TAROT_RESUME_EXPIRED' || previous && Date.parse(previous.expiresAt) <= Date.now());
        state.checkoutPending = false; syncPackageUI();
        if (!state.authorityExpired) q(root, '[data-wtx-price-status]').textContent = text('checkout_refresh_error');
      });
    }
    function checkout(authorityRetried) {
      if (state.checkoutPending || !state.preview || state.authorityExpired) return;
      var api = window.DeckauraDeepReading, status = q(root, '[data-wtx-price-status]');
      clearCheckoutTimer(); clearCartReview(); dismissReturnHint();
      var operation = {run:++checkoutRun,preview:state.preview,version:state.requestVersion,tier:state.tier,async:false}; activeCheckout = operation;
      try { if (api && api.setTier) api.setTier(state.tier, 'user'); } catch (_) {}
      var runtimeTier = api && typeof api.getSelectedTier === 'function' ? api.getSelectedTier() : '';
      if (!api || typeof api.checkoutNow !== 'function' || runtimeTier !== state.tier || !api.isPriceReady || !api.isPriceReady()) {
        if (status) status.textContent = text('price_not_ready'); retryPricing(); return;
      }
      state.checkoutPending = true; syncPackageUI();
      lastCheckoutCode = '';
      funnel('begin_checkout', {tier:state.tier,package_name:packageName(state.tier),week_position:state.timing}, 'begin_checkout:' + state.preview.readingId + ':' + state.tier);
      var started = false, authoritativeOutcome = false;
      try {
        if (typeof api.checkoutNowAsync === 'function') {
          authoritativeOutcome = true; started = true; operation.async = true;
          Promise.resolve(api.checkoutNowAsync()).then(function (outcome) {
            if (!checkoutCurrent(operation)) return;
            if (outcome && outcome.ok === true) return;
            if (authorityRetried !== true && lastCheckoutCode === 'WEEKLY_TAROT_PREVIEW_EXPIRED_OR_INVALID') { resumeCheckout(); return; }
            state.checkoutPending = false; syncPackageUI();
            if (status) status.textContent = checkoutCartReviewPending() ? '' : text(outcome && outcome.reason === 'checkout_timeout' ? 'checkout_timeout' : 'checkout_error');
          }).catch(function () { if (!checkoutCurrent(operation)) return; state.checkoutPending = false; syncPackageUI(); if (status) status.textContent = checkoutCartReviewPending() ? '' : text('checkout_error'); });
        } else started = api.checkoutNow() === true;
      } catch (_) { started = false; }
      track('weekly_checkout_clicked', {tier:state.tier,week_position:state.timing});
      if (!started) { if (!checkoutCurrent(operation)) return; state.checkoutPending = false; syncPackageUI(); if (status) status.textContent = text('checkout_error'); return; }
      if (!authoritativeOutcome && state.checkoutPending && !operation.prepareStarted) checkoutTimer = window.setTimeout(function () { if (!checkoutCurrent(operation) || !state.checkoutPending) return; state.checkoutPending = false; syncPackageUI(); if (status) status.textContent = text('checkout_timeout'); }, 20000);
    }

    restore(); syncChoices(); syncPackageUI();
    q(root, '[data-wtx-start]').addEventListener('click', function (event) { event.preventDefault(); if (state.checkoutPending) return; refreshWeek(); setup.hidden = false; result.hidden = true; invalidatePreview(); showStep(state.sign ? 'focus' : 'sign', true, true); funnel('reading_start', {week:week.key,source:'hero'}, 'reading_start'); });
    qa(root, '[data-wtx-progress]').forEach(function (button) { button.addEventListener('click', function () { if (!button.disabled) showStep(button.getAttribute('data-wtx-progress'), false, true); }); });
    qa(root, '[data-wtx-sign]').forEach(function (button) {
      button.addEventListener('click', function (event) { state.sign = button.getAttribute('data-wtx-sign'); invalidatePreview(); syncChoices(); save(); track('weekly_sign_selected', {sun_sign:state.sign,source:'direct'}); if (event.detail > 0) window.setTimeout(function () { if (state.sign === button.getAttribute('data-wtx-sign') && state.step === 'sign') showStep('focus', true, true); }, 140); });
      addRadioKeyboard(button, '[data-wtx-sign]');
    });
    q(root, '[data-wtx-find-sign]').addEventListener('click', function () {
      var birth = q(root, '[data-wtx-birth]'), resolved = sunSign(birth.value);
      if (!resolved) { birth.setAttribute('aria-invalid','true'); birth.focus(); return; }
      birth.removeAttribute('aria-invalid'); state.sign = resolved; invalidatePreview(); syncChoices(); save(); track('weekly_sign_selected', {sun_sign:state.sign,source:'birth_date'}); showStep('focus', true, true);
    });
    qa(root, '[data-wtx-focus]').forEach(function (button) {
      button.addEventListener('click', function () { state.focus = button.getAttribute('data-wtx-focus'); invalidatePreview(); syncChoices(); save(); track('weekly_focus_selected', {focus:state.focus}); });
      addRadioKeyboard(button, '[data-wtx-focus]');
    });
    q(root, '[data-wtx-timing]').addEventListener('change', function (event) { if (ALLOWED_TIMING.indexOf(event.target.value) >= 0) { state.timing = event.target.value; invalidatePreview(); syncChoices(); save(); track('weekly_timing_selected', {week_position:state.timing}); } });
    q(root, '[data-wtx-next="focus"]').addEventListener('click', function () { showStep('focus', false, true); });
    q(root, '[data-wtx-back="sign"]').addEventListener('click', function () { showStep('sign', false, true); });
    q(root, '[data-wtx-question]').addEventListener('input', function (event) { state.question = event.target.value.slice(0, 240); event.target.removeAttribute('aria-invalid'); invalidatePreview(); syncChoices(); save(); });
    q(root, '[data-wtx-reveal]').addEventListener('click', reveal);
    q(root, '[data-wtx-adjust]').addEventListener('click', returnToSetup);
    q(root, '[data-wtx-edit-offer]').addEventListener('click', returnToSetup);
    q(root, '[data-wtx-again]').addEventListener('click', function () {
      if (state.checkoutPending) return;
      refreshWeek();
      result.hidden = true; setup.hidden = false; invalidatePreview(); state.sign = ''; state.focus = ''; state.timing = timingForToday(); state.question = ''; state.tier = 'deeper';
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      showStep('sign', true, true); q(root, '[data-wtx-question]').value = ''; syncChoices();
    });
    qa(root, '[data-wtx-package]').forEach(function (button) {
      button.addEventListener('click', function () {
        var tier = button.getAttribute('data-wtx-package'); if (!selectPackage(tier)) return;
        var api = window.DeckauraDeepReading; try { if (api && api.setTier) api.setTier(tier, 'user'); } catch (_) {}
        syncPackageUI();
        track('weekly_package_selected', {tier:tier}); funnel('package_selected', {tier:tier,package_name:packageName(tier)}, 'package_selected:' + tier);
      });
      addRadioKeyboard(button, '[data-wtx-package]');
    });
    qa(root, '[data-wtx-checkout]').forEach(function (button) { button.addEventListener('click', function () { checkout(false); }); });
    q(root, '[data-wtx-price-retry]').addEventListener('click', retryPricing);
    window.addEventListener('pageshow', function (event) { if (event.persisted) { checkoutRun += 1; activeCheckout = null; clearCheckoutTimer(); clearCartReview(); state.checkoutPending = false; syncPackageUI(); updateSticky(); } });
    if ('IntersectionObserver' in window && mainCheckout) {
      new IntersectionObserver(function (entries) { mainCheckoutVisible = entries.some(function (entry) { return entry.isIntersecting; }); updateSticky(); }, {threshold:.15}).observe(mainCheckout);
    }
    setup.hidden = false; result.hidden = true; showStep(state.sign ? 'focus' : 'sign', false, false);
    track('weekly_tarot_view', {week:week.key,returning:Boolean(state.sign)});
  }

  function prepare(root) {
    if (!root || root.getAttribute('data-wtx-ready') === 'true') return;
    if (i18n()) { init(root); return; }
    if (root.getAttribute('data-wtx-loading') === 'true') return;
    root.setAttribute('data-wtx-loading', 'true');
    var setup = q(root, '[data-wtx-setup]'), recovery = q(root, '[data-wtx-module-recovery]'), retry = q(root, '[data-wtx-module-retry]');
    if (setup) setup.inert = true;
    if (retry) retry.disabled = true;
    loadDependency('weekly-tarot-enterprise-v3-i18n.js', i18n).then(function () {
      root.removeAttribute('data-wtx-loading'); if (setup) setup.inert = false; if (recovery) recovery.hidden = true; init(root);
    }).catch(function () {
      root.removeAttribute('data-wtx-loading'); if (recovery) recovery.hidden = false;
      if (retry) { retry.disabled = false; retry.onclick = function () { prepare(root); }; }
    });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-wtx-root]'), prepare); }
  if (document.querySelector('[data-wtx-root]') || document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (event) { prepare(event.target.querySelector('[data-wtx-root]')); });
})();
